/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Manage_Storage_Remove_TitleInputs */



/**
* | output |
* | --- |
* | "Schedule storage removal?" |
*
* @param {Partner_Manage_Storage_Remove_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_manage_storage_remove_title = /** @type {((inputs?: Partner_Manage_Storage_Remove_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Manage_Storage_Remove_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Speicherentfernung planen?")
	return /** @type {LocalizedString} */ ("Schedule storage removal?")
});